import React from 'react';

import Heading from 'grommet/components/Heading';

export default () => (
  <>
    <Heading tag="h3">PRIVACY & DATA PROTECTION POLICY</Heading>
    <Heading tag="h3">PRIVACY POLICY</Heading>

    <Heading tag="h3">1. INTRODUCTION AND DEFINITIONS</Heading>
    <div className="my-2">1.1 This is the privacy policy for https://bookings.m8group.co.uk</div>
    <div className="my-2">
      1.2 The term "Website" means the website accessible from this URL, being https://bookings.m8group.co.uk.
    </div>
    <div className="my-2">1.3 Other defined terms shall have the meanings given to them in the Terms of Use.</div>
    <div className="my-2">
      1.4 The terms "Data Controller" and "Personal Data" shall have the meanings given to them in the Data Protection
      Act 1998 (the "Act").
    </div>
    <div className="my-2">
      1.5 For the purposes of the Act, the Data Controller shall be: Motive8 Limited (company number 04013702) of
      Gibraltar House, Govett Avenue, Shepperton, TW17 8AB. Any reference to "we" or "us" shall be a reference to
      Motive8 Limited, as the context permits.
    </div>
    <div className="my-2">
      1.6 This privacy policy (together with our terms of and any other documents referred to in it) sets out the basis
      on which any Personal Data we collect from you, or that you provide to us, will be processed by us.
    </div>
    <div className="my-2">
      1.7 Please read the following carefully to understand our views and practices regarding your Personal Data and how
      we will treat it. By visiting the Website, you are accepting and consenting to the practices described in this
      policy. If you have any questions at all about this privacy policy or the Website, please email{' '}
      <a href="mailto:jenny.cromack@m8group.co.uk">jenny.cromack@m8group.co.uk</a>.
    </div>
    <div className="my-2">
      1.8 Service – This refers to any service offered to motive8 Group Ltd Customers. This includes, but is not limited
      to, gym design and gym installation, management services, maintenance services, fitness services such as classes,
      gym inductions, gym memberships, personal training, sports massage, equipment sales and rentals.
    </div>
    <div className="my-2">1.9 Our nominated representative for the purpose of the Act is Ms Jenny Cromack.</div>

    <Heading tag="h3">2. INFORMATION WE COLLECT FROM YOU</Heading>
    <div className="my-2">2.1 We will collect and process the following Personal Data (and other data):</div>
    <div className="my-2">
      (a) Information you give us. This is information about you that you give us by filling in forms on the Website
      (including health questionnaires which may include sensitive personal data) or by corresponding with us by phone,
      e-mail or otherwise. It includes information you provide when you register to use the Website, subscribe to our
      service, search for a product, place an order on the Website, participate in discussion boards or other social
      media functions on our site, enter a competition, promotion or survey, click and use links provided throughout,
      use and engage with the website in any way and when you report a problem with the Website. The information you
      give us may include your name, address, e-mail address and phone number, financial and credit card information,
      personal description and photograph;
    </div>
    <div className="my-2">
      (b) Information we collect about you. With regard to each of your visits to the Website we will automatically
      collect the following information:
      <br />
      (i) technical information, including the Internet protocol (IP) address used to connect your computer or
      alternative device to the Internet, your login information, browser type and version, time zone setting, browser
      plug-in types and versions, operating system and platform; and
      <br />
      (ii) information about your visit, including the full Uniform Resource Locators ("URL"), clickstream to, through
      and from the Website (including date and time), products you viewed or searched for' page response times, download
      errors, length of visits to certain pages, page interaction information (such as scrolling, clicks, and
      mouse-overs), methods used to browse away from the page, and any phone number used to call our customer service
      number.
    </div>
    <div className="my-2">
      (c) Information we receive from other sources. This is information we receive about you if you use any of the
      other websites we operate or the other services we provide. We are working closely with third parties (including,
      for example, business partners, sub-contractors in payment and delivery services). We will notify you when we
      receive information about you from them and the purposes for which we intend to use that information.
    </div>
    <div className="my-2">
      (d) We will store your data for a minimum of 3 years after your move out date from the development in which the
      residential gym you used was located, or in the case of our commercial and corporate facilities, 3 years after you
      last attended the facility/used one of our services. After 3 years if you wish to delete your data then you will
      need to inform the Data Protection Officer (
      <a href="mailto:jenny.cromack@m8group.co.uk">jenny.cromack@m8group.co.uk</a>). If you do not get in contact with
      us, then your data will be stored indefinitely.
      <br />
      Please note the above only applies to those who are over 18 years of age, should anyone wish to delete their data
      who is under the age of 18 then this data will be stored for a minimum of 5 years.
    </div>

    <Heading tag="h3">3. USES MADE OF THE INFORMATION</Heading>
    <div className="my-2">3.1 We use information held about you in the following ways:</div>
    <div className="my-2">
      (a) Information you give to us. We will use this information:
      <br />
      (i) to carry out our obligations arising under the Terms of Use;
      <br />
      (ii) to provide you with information about other goods and services that are similar to those that you have
      already purchased, enquired about or otherwise engaged with;
      <br />
      (iii) to notify you about changes to the Website; and
      <br />
      (iv) to ensure that content from the Website is presented in the most effective manner for you and for your
      computer or internet enabled device.
    </div>
    <div className="my-2">3.2 Information we collect about you. We will use this information:</div>
    <div className="my-2">
      (a) to administer the Website and for internal operations, including troubleshooting, data analysis, testing,
      research, statistical and survey purposes;
    </div>
    <div className="my-2">
      (b) to improve the Website to ensure that content is presented in the most effective manner for you and for your
      computer or internet enabled device;
    </div>
    <div className="my-2">
      (c) to allow you to participate in interactive features of our service, when you choose to do so;
    </div>
    <div className="my-2">(d) as part of our efforts to keep the Website safe and secure;</div>
    <div className="my-2">
      (e) to measure or understand the effectiveness of advertising we serve to you and others, and to deliver relevant
      advertising to you;
    </div>
    <div className="my-2">
      (f) to make suggestions and recommendations to you and other users of the Website about goods or services that may
      interest you or them.
    </div>
    <div className="my-2">
      3.3 Information we receive from other sources. We will combine this information with information you give to us
      and information we collect about you. We will use this information and the combined information for the purposes
      set out above (depending on the types of information we receive).
    </div>

    <Heading tag="h3">4. DISCLOSURE OF YOUR INFORMATION</Heading>
    <div className="my-2">
      4.1 We will disclose your personal information and Personal Data to third parties (including companies in our
      group):
    </div>
    <div className="my-2">(a) to give effect to clause 3.1 above;</div>
    <div className="my-2">
      (b) in the event that we sell or buy any business or assets, in which case we will disclose your Personal Data to
      the prospective seller or buyer of such business or assets.
    </div>
    <div className="my-2">
      (c) if we are acquired by a third party, in which case Personal Data held by it about its customers will be one of
      the transferred assets.
    </div>
    <div className="my-2">
      (d) if we are under a duty to disclose or share your Personal Data in order to comply with any legal obligation,
      or in order to enforce or apply Terms of Use and other agreements; or to protect the rights, property, or safety
      of the Website, our customers, or others. This includes exchanging information with other companies and
      organisations for the purposes of fraud protection and credit risk reduction.
    </div>
    <div className="my-2">4.2 Personal Data may also be shared with:</div>
    <div className="my-2">
      (a) Estate Management companies for whom we deliver inductions, classes and other fitness services at their
      on-site gyms for private residential facilities. Only data relating to the specific site they are contracted to
      manage would be shared.
    </div>
    <div className="my-2">
      (b) Estate Management firms who have an agreement with us to host a booking platform to manage their gym bookings.
      Only data for the specific site they are contracted to manage would be shared.
    </div>
    <div className="my-2">
      (c) Corporate clients who contract us to perform fitness or wellbeing related services at their offices. Only data
      related to their employees and tenants would be shared.
    </div>
    <div className="my-2">
      (d) Third party organisations that provide applications/functionality, data processing or IT services to us.
      <br />
      (i) We use third parties to support us in providing our services and to help provide, run and manage our internal
      IT systems. For example, providers of information technology, cloud based software as a service providers, website
      hosting and management, data back-up, security and storage services. The servers powering and facilitating that
      cloud infrastructure are located in secure data centers in the UK.
    </div>

    <Heading tag="h3">5. WHERE WE STORE YOUR PERSONAL DATA</Heading>
    <div className="my-2">
      5.1 By submitting your Personal Data, you agree to this transfer, storing or processing. We will take all steps
      reasonably necessary to ensure that your Personal Data is treated securely and in accordance with this privacy
      policy.
    </div>
    <div className="my-2">
      5.2 All information you provide to us is stored on our secure servers including Active Campaign. Any payment
      transactions will be encrypted using SSL technology. Where we have given you (or where you have chosen) a password
      which enables you to access certain parts of the Website, you are responsible for keeping this password
      confidential. We ask you not to share a password with anyone.
    </div>
    <div className="my-2">
      5.3 Unfortunately, the transmission of information via the internet is not completely secure. Although we will do
      our best to protect your Personal Data, we cannot guarantee the security of your Personal Data transmitted to the
      Website; any transmission is at your own risk. Once we have received your information, we will use strict
      procedures and security features to try to prevent unauthorised access.
    </div>

    <Heading tag="h3">6. YOUR RIGHTS</Heading>
    <div className="my-2">
      6.1 You have the right to ask us not to process your Personal Data for marketing purposes. We will usually inform
      you (before collecting your Personal Data) if we intend to use your Personal Data for such purposes or if we
      intend to disclose your information to any third party for such purposes. You can exercise your right to prevent
      such processing by checking certain boxes in the account area where you can control your Personal Data options and
      where required on the forms we use to collect your Personal Data. You can also exercise the right at any time by
      contacting us using the contact details set out in the Terms of Use.
    </div>
    <div className="my-2">
      6.2 The Website may from time to time, contain links to and from the sites of our partner networks, advertisers
      and affiliates. If you follow a link to any of these websites, please note that these websites have their own
      privacy policies and that we do not accept any responsibility or liability for these policies. Please check these
      policies before you submit any Personal Data to these websites.
    </div>
    <div className="my-2">
      6.3 Please refer to www.dataprotection.gov.uk for further information about your rights under the Act. You have
      the right to receive a copy of the information we hold about you by sending a request in writing (with a fee of
      £10) to us using the contact details set out in the terms of use.
    </div>

    <Heading tag="h3">7. COOKIES</Heading>
    <div className="my-2">
      7.1 The Website uses cookies to function and distinguish you from other users of the Website. This helps us to
      provide you with a good experience when you browse the Website and also allows us to improve. For detailed
      information on the cookies we use and the purposes for which we use them see our Cookie Policy below.
    </div>
    <div className="my-2">
      7.2 For more information about Cookies and how they are used please refer to{' '}
      <a href="https://ico.org.uk/for-the-public/online/cookies/">https://ico.org.uk/for-the-public/online/cookies/</a>.
    </div>

    <Heading tag="h3">8. CHANGES TO OUR PRIVACY POLICY</Heading>
    <div className="my-2">
      8.1 Any changes we make to our privacy policy in the future will be posted on this page and, where appropriate,
      notified to you by e-mail. Please check back frequently to see any updates or changes to our privacy policy.
    </div>
    <br />
    <h2>DATA PROTECTION POLICY</h2>

    <Heading tag="h3">1. INTRODUCTION AND DEFINITIONS</Heading>
    <div className="my-2">
      1.1 This is the Data Protection Policy for Motive8 Limited (company number 04013702) of Gibraltar House, Govett
      Avenue, Shepperton, TW17 8AB.
    </div>
    <div className="my-2">1.2 The nominated Data Protection Officer is Jenny Cromack.</div>
    <div className="my-2">
      1.3 'Customer'. Any person or company who signs up for the services offered by motive8 Group Ltd in addition to
      voluntarily signing up for online offers and newsletters through any associated websites (
      <a href="http://www.m8group.co.uk/">www.m8group.co.uk</a>,{' '}
      <a href="http://www.m8north.co.uk/">www.m8north.co.uk</a>,{' '}
      <a href="http://www.motive8iq.co.uk/">www.motive8iq.co.uk</a>, www.bookings.m8group.co.uk).
    </div>
    <div className="my-2">1.4 ''Website''. The website is https://bookings.m8group.co.uk.</div>

    <Heading tag="h3">2. DATA PROTECTION STATEMENT</Heading>
    <div className="my-2">
      2.1 To provide you with the correct advice and support in relation to our facilities and the services we offer, we
      need to hold and process certain personal data relating to you, including your identity, contact details and
      sensitive information relating to your health.
    </div>
    <div className="my-2">
      2.2 By signing up for any services we offer you consent to allowing us to process this information.
    </div>

    <Heading tag="h3">3. TERMS OF USE – WEBSITE</Heading>
    <div className="my-2">
      3.1 The term "Website" means the website accessible from this URL, being www.bookings.m8group.co.uk
    </div>
    <div className="my-2">3.2 Other defined terms shall have the meanings given to them in the Terms of Use.</div>
    <div className="my-2">
      3.3 The terms "Data Controller" and "Personal Data" shall have the meanings given to them in the Data Protection
      Act 1998 (the "Act").
    </div>
    <div className="my-2">
      3.4 For the purposes of the Act, the Data Controller shall be Motive8 Limited (company number 04013702) of
      Gibraltar House, Govett Avenue, Shepperton, TW17 8AB.
    </div>
    <div className="my-2">
      3.5 The privacy policy (together with our terms of and any other documents referred to in it) sets out the basis
      on which any Personal Data we collect from you, or that you provide to us, will be processed by us. Our privacy
      policy can be found at above or at{' '}
      <a href="https://bookings.m8group.co.uk/privacy-policy/">https://bookings.m8group.co.uk/privacy-policy/</a>
    </div>
    <div className="my-2">
      3.6 Please read the following carefully to understand our views and practices regarding your Personal Data and how
      we will treat it. By visiting the Website, you are accepting and consenting to the practices described in this
      policy. If you have any questions at all about this privacy policy or the Website, please email{' '}
      <a href="mailto:jenny.cromack@m8group.co.uk">jenny.cromack@m8group.co.uk</a>.
    </div>
    <div className="my-2">3.7 Our nominated representative for the purpose of the Act is Ms Jenny Cromack.</div>

    <Heading tag="h3">4. INFORMATION WE COLLECT FROM YOU</Heading>
    <div className="my-2">4.1 We will collect and process the following Personal Data (and other data):</div>
    <div className="my-2">
      (a) Information you give us. This is information about you that you give us by filling in forms in our gym or on
      the Website (including health questionnaires which may include sensitive personal data) or by corresponding with
      us by phone, e-mail or otherwise. It includes information you provide when you register to use the Website,
      subscribe to our services, place an order on the Website, participate in discussion boards or other social media
      functions on our site, enter a competition, promotion or survey, click and use links provided throughout, use and
      engage with the website in any way and when you report a problem with the Website. The information you give us may
      include your name, address, e-mail address and phone number, financial and credit card information, personal
      description and photograph;
    </div>
    <div className="my-2">
      (b) Information we collect about you. With regard to each of your visits to the Website we will automatically
      collect the following information:
      <br /> (i) technical information, including the Internet protocol (IP) address used to connect your computer or
      alternative device to the Internet, your login information, browser type and version, time zone setting, browser
      plug-in types and versions, operating system and platform; and
      <br /> (ii) information about your visit, including the full Uniform Resource Locators ("URL"), clickstream to,
      through and from the Website (including date and time), products you viewed or searched for' page response times,
      download errors, length of visits to certain pages, page interaction information (such as scrolling, clicks, and
      mouse-overs), methods used to browse away from the page, and any phone number used to call our customer service
      number.
    </div>
    <div className="my-2">
      (c) Information we receive from other sources. This is information we receive about you if you use any of the
      other websites we operate or the other services we provide. We are working closely with third parties (including,
      for example, business partners, sub-contractors in payment and delivery services). We will notify you when we
      receive information about you from them and the purposes for which we intend to use that information.
    </div>
    <div className="my-2">
      (d) We will store your data for a minimum of 3 years after your move out date from the development in which the
      residential gym you used was located, or in the case of our commercial and corporate facilities, 3 years after you
      last attended the facility/used one of our services. After 3 years if you wish to delete your data then you will
      need to inform the Data Protection Officer (
      <a href="mailto:jenny.cromack@m8group.co.uk">jenny.cromack@m8group.co.uk</a>). If you do not get in contact with
      us, then your data will be stored indefinitely.
      <br />
      Please note the above only applies to those who are over 18 years of age, should anyone wish to delete their data
      who is under the age of 18 then this data will be stored for a minimum of 5 years.
    </div>

    <Heading tag="h3">5. USES MADE OF THE INFORMATION</Heading>
    <div className="my-2">5.1 We use information held about you in the following ways:</div>
    <div className="my-2">
      (a) Information you give to us. We will use this information:
      <br />
      (i) to carry out our obligations arising under the Terms of Use;
      <br /> (ii) to provide you with information about other goods and services that are similar to those that you have
      already purchased, enquired about or otherwise engaged with;
      <br /> (iii) to notify you about changes to the Website; and
      <br /> (iv) to ensure that content from the Website is presented in the most effective manner for you and for your
      computer or internet enabled device.
    </div>
    <div className="my-2">5.2 Information we collect about you. We will use this information:</div>
    <div className="my-2">
      (a) to supply our gym membership services including classes, personal training and gym memberships;
    </div>
    <div className="my-2">
      (b) to administer the Website and for internal operations, including troubleshooting, data analysis, testing,
      research, statistical and survey purposes;
    </div>
    <div className="my-2">
      (c) to improve the Website to ensure that content is presented in the most effective manner for you and for your
      computer or internet enabled device;
    </div>
    <div className="my-2">
      (d) to allow you to participate in interactive features of our service, when you choose to do so;
    </div>
    <div className="my-2">(e) as part of our efforts to keep the Website safe and secure;</div>
    <div className="my-2">
      (f) to measure or understand the effectiveness of advertising we serve to you and others, and to deliver relevant
      advertising to you;
    </div>
    <div className="my-2">
      (g) to make suggestions and recommendations to you and other users of the Website about goods or services that may
      interest you or them.
    </div>
    <div className="my-2">
      5.3 Information we receive from other sources. We will combine this information with information you give to us
      and information we collect about you. We will use this information and the combined information for the purposes
      set out above (depending on the types of information we receive).
    </div>

    <Heading tag="h3">6. DISCLOSURE OF YOUR INFORMATION</Heading>
    <div className="my-2">
      6.1 We will disclose your personal information and Personal Data to third parties (including companies in our
      group):
    </div>
    <div className="my-2">(a) to give effect to clause 3.1 above;</div>
    <div className="my-2">
      (b) in the event that we sell or buy any business or assets, in which case we will disclose your Personal Data to
      the prospective seller or buyer of such business or assets.
    </div>
    <div className="my-2">
      (c) if we are acquired by a third party, in which case Personal Data held by it about its customers will be one of
      the transferred assets.
    </div>
    <div className="my-2">
      (d) if we are under a duty to disclose or share your Personal Data in order to comply with any legal obligation,
      or in order to enforce or apply Terms of Use and other agreements; or to protect the rights, property, or safety
      of the Website, our customers, or others. This includes exchanging information with other companies and
      organisations for the purposes of fraud protection and credit risk reduction.
    </div>

    <Heading tag="h3">7. WHERE WE STORE YOUR PERSONAL DATA</Heading>
    <div className="my-2">
      7.1 By submitting your Personal Data, you agree to this transfer, storing or processing. We will take all steps
      reasonably necessary to ensure that your Personal Data is treated securely and in accordance with this privacy
      policy.
    </div>
    <div className="my-2">
      7.2 All information you provide to us is stored on our secure servers including Active Campaign. Any payment
      transactions will be encrypted using SSL technology. Where we have given you (or where you have chosen) a password
      which enables you to access certain parts of the Website, you are responsible for keeping this password
      confidential. We ask you not to share a password with anyone. Any paperwork completed when signing up for the
      services we offer will be stored securely.
    </div>
    <div className="my-2">
      7.3 Unfortunately, the transmission of information via the internet is not completely secure. Although we will do
      our best to protect your Personal Data, we cannot guarantee the security of your Personal Data transmitted to the
      Website; any transmission is at your own risk. Once we have received your information, we will use strict
      procedures and security features to try to prevent unauthorised access.
    </div>

    <Heading tag="h3">8. YOUR RIGHTS</Heading>
    <div className="my-2">
      8.1 You have the right to ask us not to process your Personal Data for marketing purposes. We will usually inform
      you (before collecting your Personal Data) if we intend to use your Personal Data for such purposes or if we
      intend to disclose your information to any third party for such purposes. You can exercise your right to prevent
      such processing by checking certain boxes in the account area where you can control your Personal Data options and
      where required on the forms we use to collect your Personal Data. You can also exercise the right at any time by
      contacting us using the contact details set out in the Terms of Use.
    </div>
    <div className="my-2">
      8.2 The Website may from time to time, contain links to and from the sites of our partner networks, advertisers
      and affiliates. If you follow a link to any of these websites, please note that these websites have their own
      privacy policies and that we do not accept any responsibility or liability for these policies. Please check these
      policies before you submit any Personal Data to these websites.
    </div>
    <div className="my-2">
      8.3 Please refer to www.dataprotection.gov.uk for further information about your rights under the Act. You have
      the right to receive a copy of the information we hold about you by sending a request in writing (with a fee of
      £10) to us using the contact details set out in the terms of use.
    </div>

    <Heading tag="h3">9. COOKIES</Heading>
    <div className="my-2">
      9.1 The Website uses cookies to function and distinguish you from other users of the Website. This helps us to
      provide you with a good experience when you browse the Website and also allows us to improve. For detailed
      information on the cookies we use and the purposes for which we use them see our Cookie Policy.
    </div>
    <div className="my-2">
      9.2 For more information about Cookies and how they are used please refer to{' '}
      <a href="https://ico.org.uk/for-the-public/online/cookies/">https://ico.org.uk/for-the-public/online/cookies/</a>.
    </div>

    <Heading tag="h3">10. CHANGES TO OUR DATA PROTECTION POLICY</Heading>
    <div className="my-2">
      10.1 Any changes we make to our privacy policy in the future will be posted on this page and, where appropriate,
      notified to you by e-mail. Please check back frequently to see any updates or changes to our privacy policy.
    </div>

    <div className="my-4">Updated Sept 2026</div>
  </>
);
